import {Component, OnInit, ViewChild} from '@angular/core';
import {DiagnosisService} from '../../../../services/form/diagnosis.service';
import {DiagnosisDifficultyConfigurationModel} from '../../../../models/forms/custom/diagnosis/diagnosis-difficulty-configuration.model';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {StaticDataService} from '../../../../services/static-data.service';
import {DiagnosisDifficultyEnumsConfigurationModel} from '../../../../models/forms/custom/diagnosis/diagnosis-difficulty-enums-configuration.model';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {ConfigurationService} from '../../configuration.service';

@Component({
  selector: 'app-diagnosis-difficulty-configuration',
  templateUrl: './diagnosis-difficulty-configuration.component.html',
  styleUrls: ['./diagnosis-difficulty-configuration.component.scss']
})
export class DiagnosisDifficultyConfigurationComponent implements OnInit {
  @ViewChild('fieldTable') fieldTable: TdoTableV2Component;

  isLoading = true;
  configs: DiagnosisDifficultyConfigurationModel[];
  selectedConfig: DiagnosisDifficultyConfigurationModel;
  selectedEnumConfig: DiagnosisDifficultyEnumsConfigurationModel;

  constructor(private diagnosisService: DiagnosisService,
              private staticDataService: StaticDataService,
              public configurationService: ConfigurationService) { }

  ngOnInit(): void {
    this.diagnosisService.getConfigs().subscribe((res) => {
      this.configs = res;
      this.selectedConfig = this.configs[0];
      this.isLoading = false;
    });
  }

  onRowSelected(event: TdoTableSelectionEvent) {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.selectedConfig = event.row.model;
          return;
        } else {
          this.fieldTable.selectionControl.select(this.selectedConfig);
        }
      });
    } else {
      this.selectedConfig = event.row.model;
    }
  }

  onDescriptionFinished(event: any) {
    this.selectedConfig.Description = event;
    this.save();
  }

  save() {
    this.diagnosisService.saveConfig(this.selectedConfig).subscribe((res) => {
      this.configurationService.setClean();
    });
  }

  onDifficultyChange(event: any) {
    this.selectedConfig.DifficultyLevel = event.target.value;
    this.save();
  }

  onDifficultyInput(event: any) {
    this.selectedConfig.DifficultyLevel = event;
    this.save();
  }

  getDescriptorName(ValidValueItemID: any) {
    const enu = this.staticDataService.validValueItems.find(p => p.ValidValueItemId === ValidValueItemID);
    if (enu) {
      return enu.ItemDisplayValue;
    }
    return '';
  }

  onEnumDifficultyChange(event: any, model: DiagnosisDifficultyEnumsConfigurationModel) {
    this.selectedEnumConfig = model;
    this.selectedEnumConfig.DifficultyLevel = event.target.value;
    this.save();
  }

  onEnumDifficultyInput(event: any) {
    this.selectedEnumConfig.DifficultyLevel = event;
    this.save();
  }

  onEnumConfigSelected(event: TdoTableSelectionEvent) {
    this.selectedEnumConfig = event.row.model;
  }
}
